import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import ImplementationOptionsImage from './ImplementationOptionsImage'

const copy = {
  heading: `Complete CDP`,
  description: `With Engage, Unify Plus, and Unify, companies can start anywhere and activate everywhere, including their data warehouse, to get the most out of their current tech stack.`,
  columns: [
    {
      heading: `Real-time behavioral events`,
      description: `Support real-time use cases by capturing events from native sources, build audiences, and orchestrate personalized journeys across 450+ destinations.`,
    },
    {
      heading: `Warehouse data`,
      description: `Leverage data already stored in the warehouse to enrich unified profiles, and build complex audiences to precisely target customers with personalized communications.`,
    },
  ],
}

const ImplementationOptions = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionComponent variant="centered" id="which-plan-is-right-for-you">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <StyledSectionContents>
        <ImplementationOptionsImage />
        <ColumnTrack columns={1} overrides={{ lg: 2 }}>
          {copy.columns.map((column) => (
            <CopyTextBase key={column.heading}>
              <CopyText.Heading variant="h3" tag="h2">
                {column.heading}
              </CopyText.Heading>
              <CopyText.Description variant="pLarge">{column.description}</CopyText.Description>
            </CopyTextBase>
          ))}
        </ColumnTrack>
        <Button
          size="medium"
          color="primary"
          variant="filled"
          href={getAbsoluteUrl(`/demo/`, pageConfig)}
          onClick={() =>
            trackButtonClick({
              buttonText: `Get a demo`,
              targetUrl: `/demo/`,
              buttonId: `pricing-cdp-page-complete-cdp-section-demo`,
            })
          }
        >
          Get a demo
        </Button>
      </StyledSectionContents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;
  max-width: 980px;

  ${Section.Wrapper} {
    padding-top: 120px;

    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 80px;
    }
  }
`

const StyledSectionContents = styled(Section.Contents)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 44px;
`

export default ImplementationOptions
